<template>
  <div class="load-file">
    <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--colored">
      <i class="material-icons">open_in_browser</i><br>
      <span>{{ i18n().tapOrDrop }}</span>
    </button>
    <input class="hidden-file" type="file" v-on:change="handleInputChange">
  </div>
</template>

<script>
  import i18n from "i18n"
  import { dropZoneState } from "./GlobalDropZone.js";

  export default {
    name: 'load-file',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      i18n() { return i18n().loadFile },
      handleInputChange(e) {
        var files = e.target.files || e.dataTransfer.files;
        if (!files.length) return;
        this.handleFileSelected(files[0])
      },
      handleFileSelected(file) {
        this.$emit('file', file)
      }
    },
    mounted() {
      dropZoneState.dropReceiver = (files) => {
        console.log("DROP ZONE RECEIVER", files)
        this.handleFileSelected(files[0])
      }
    },
    beforeDestroy() {
      dropZoneState.dropReceiver = null
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .load-file {
    position: relative;
  }

  .load-file button {
    width: 230px;
    height: 230px;
  }
  .load-file button span {
    display: block;
    margin-top: 23px;
    font-size: 12px;
  }

  .load-file input.hidden-file {
    border: none;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom:0;
    width: 100%;
    height: 100%;
    pointer-events: all;
    cursor: pointer;
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// LoadFile.vue?6b5c681b